import React from "react";

import { PublisherAPI } from "apis";
import GeoCountrySelector from "../../GeoCountrySelector";

import { MESSAGE } from "constants/Message";

import {
  inputClass,
  buttonModalCancelClass,
  buttonModalConfirmClass,
} from "helpers/StyleClass";

import { validateEmail } from "helpers/Utils";

class CreatePublisherView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      msg: [],
      isSaving: false,

      name: "",
      userEmail: "",
      geoCountryId: null,

      currentStep: 1,
    };

    this.handleCreatePublisher = this.handleCreatePublisher.bind(this);
  }

  async handleCreatePublisher() {
    this.setState({ msg: [] });

    try {
      const { name, userEmail, geoCountryId } = this.state;

      if (!name || name === "") {
        throw "Please fill in the 'Publisher Name' (Usually it's the company name)";
      }
      if (!userEmail || userEmail === "") {
        throw "Please fill in 'User Email' for new user";
      }
      if (!validateEmail(userEmail)) {
        throw "Please fill in 'User Email' in the correct email format";
      }
      if (!geoCountryId) {
        throw "Please select 'Country'";
      }

      const param = {
        name,
        userEmail,
        geoCountryId,
      };

      this.setState({
        isSaving: true,
      });

      const result = await PublisherAPI.createPublisher(param);
      console.log(result);

      this.setState({
        isSaving: false,
        msg: ["Publisher created!", MESSAGE.SUCCESS],
      });

      this.props.handleUpdateData();
    } catch (err) {
      console.log(err);
      this.setState({
        msg: [err.toString(), MESSAGE.ERROR],
        isSaving: false,
      });
    }
  }

  render() {
    const { handleClose } = this.props;

    const {
      msg,
      isSaving,

      name,
      userEmail,
      geoCountryId,
    } = this.state;

    return (
      <div>
        <div className="rounded mb-4 bg-gray-200 px-4 pb-4 pt-2">
          <label className="font-semibold text-gray-800">Publisher Name</label>
          <div className="mb-4">
            <input
              type="text"
              className={inputClass}
              value={name}
              onChange={(e) => this.setState({ name: e.target.value })}
            ></input>
          </div>
          <label className="font-semibold text-gray-800">User Email</label>
          <div className="mb-4">
            <input
              type="email"
              className={inputClass}
              value={userEmail}
              onChange={(e) => this.setState({ userEmail: e.target.value })}
            ></input>
          </div>
          <label className="font-semibold text-gray-800">
            What is your invoicing country?
          </label>
          <div className="mb-4">
            <GeoCountrySelector
              selectedValue={geoCountryId}
              handleOnChange={(value) => this.setState({ geoCountryId: value })}
            ></GeoCountrySelector>
          </div>
        </div>

        <div className="mb-4">
          {msg.length !== 0 && (
            <div
              className={`rounded  p-2 font-semibold  ${
                msg[1] === MESSAGE.SUCCESS
                  ? "bg-green-100 text-green-600"
                  : "bg-red-100 text-red-600"
              }`}
            >
              {msg[0]}
            </div>
          )}
        </div>

        <div className="flex justify-end gap-2">
          {isSaving && <div className="loader"></div>}
          {!isSaving && msg[1] !== MESSAGE.SUCCESS && (
            <>
              <button
                type="button"
                className={buttonModalCancelClass}
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                type="button"
                className={buttonModalConfirmClass}
                onClick={this.handleCreatePublisher}
              >
                Create Publisher
              </button>
            </>
          )}
          {msg.length !== 0 && msg[1] === MESSAGE.SUCCESS && (
            <button
              type="button"
              className={buttonModalConfirmClass}
              onClick={handleClose}
            >
              Close
            </button>
          )}
        </div>
      </div>
    );
  }
}

export default CreatePublisherView;
